export default function report (Restangular) {
  'ngInject'
  return Restangular.all('report')
}
